import type { HTMLAttributes } from "react";

export default function AddEmojiIcon(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="14.75" width="1.5" height="7.5" rx="0.2" fill="currentColor" />
      <rect
        x="11.75"
        y="4.5"
        width="1.5"
        height="7.5"
        rx="0.2"
        transform="rotate(-90 11.75 4.5)"
        fill="currentColor"
      />
      <circle cx="6" cy="8.25" r="1.25" fill="currentColor" />
      <circle cx="11.5" cy="8.25" r="1.25" fill="currentColor" />
      <path
        d="M8.74999 14C9.28048 14 9.78913 13.7892 10.1643 13.4141C10.5392 13.0392 10.75 12.5305 10.75 12C10.7481 11.648 10.6522 11.3027 10.4726 11H7.02744C6.84783 11.3027 6.75192 11.648 6.75 12C6.75 12.5305 6.96083 13.0392 7.33575 13.4141C7.71084 13.7892 8.21951 14 8.74999 14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75586 1.9375C8.75391 1.9375 8.75195 1.9375 8.75 1.9375C4.33172 1.9375 0.75 5.51922 0.75 9.9375C0.75 14.3558 4.33172 17.9375 8.75 17.9375C13.0061 17.9375 16.4859 14.6139 16.7357 10.4205H15.2323C14.9852 13.7848 12.1774 16.4375 8.75 16.4375C5.16015 16.4375 2.25 13.5274 2.25 9.9375C2.25 6.34765 5.16015 3.4375 8.75 3.4375C8.75195 3.4375 8.75391 3.4375 8.75586 3.4375V1.9375Z"
        fill="currentColor"
      />
    </svg>
  );
}
